// @ts-ignore
import * as React from "react";
import { InfoSquareIcon } from "@skbkontur/icons";

import { FufCombineMethod } from "../../../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";

import { extractFileExtension, TableType } from "./Types";

export const getStepHeaderContent = (fufCombineMethod: FufCombineMethod, multiple: boolean = true) => (
    <>
        Загрузка файл{multiple ? "ов" : "а"} для{" "}
        {fufCombineMethod === FufCombineMethod.ReplaceThenMerge ||
        fufCombineMethod === FufCombineMethod.ReplaceThenAddToEnd
            ? "замены"
            : "добавления"}
        &nbsp;данных
    </>
);

export const getTableTypeHeaderContent = (tableType?: TableType) =>
    tableType === TableType.static ? (
        <>
            <InfoSquareIcon />
            Загрузить таблицу?
        </>
    ) : (
        <>Загрузка файлов</>
    );

export const getAcceptFilesError = (acceptFiles?: string[]) => {
    if (!acceptFiles || acceptFiles.length === 0) {
        return "Неправильный формат файла.";
    }
    return `Неправильный формат файла. Можно загрузить: ${acceptFiles?.join(", ")}.`;
};

export const getAcceptFilesErrorFromName = (fileName: string, allowExtensions: string[]) => {
    if (!allowExtensions.includes(extractFileExtension(fileName))) {
        return getAcceptFilesError(allowExtensions);
    }

    return null;
};

export const invalidFileErrorText = "Неподходящее содержимое файла.";
export const invalidFileErrorTextRSV = "Отчет не будет загружен — файл имеет неправильный формат или поврежден.";
export const periodWarningText = (periodFile: string, periodForm: string) =>
    `Отчетный период в файле "${periodFile}" отличается от отчетного периода черновика "${periodForm}". Будет выполнен импорт сотрудников и сумм в текущий период. Отчетный период "${periodForm}" в черновике не изменится.`;

export const periodWarningText2 = (periodFile: string, periodForm: string) =>
    `Отчетный период в файле "${periodFile}" отличается от отчетного периода черновика "${periodForm}". Отчетный период "${periodForm}" в черновике не изменится.`;

export const formatLoadingErrorText =
    "Загруженный файл не\u00A0соответствует формату основной формы. Загрузите файл в\u00A0формате основного документа или\u00A0заполните данные в\u00A0системе.";

export const loadFileErrorText = "При загрузке файла произошла ошибка. Попробуйте ещё раз.";
export const backendConversionErrorMessage = "Файл имеет неправильный формат";
